import { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "../../axios";
import { Link, useNavigate } from "react-router-dom";

const TestimonialList = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const handleEdit = (id) => {
    // window.location.href = `/admin/addTestimonial/${id}`;
    navigate(`/admin/addTestimonial/${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this testimonial?")) {
      axios
        .delete(`/testimonials/${id}`)
        .then(() => {
          const updated = testimonials.filter((item) => item.id !== id);
          setTestimonials(updated);
          setFilteredData(updated);
        })
        .catch((err) => {
          console.error("Error deleting testimonial:", err);
        });
    }
  };

  useEffect(() => {
    axios
      .get("/testimonials")
      .then((res) => {
        setTestimonials(res.data);
        setFilteredData(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch testimonials:", err);
      });
  }, []);

  useEffect(() => {
    const filtered = testimonials.filter((item) =>
      item.name.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchText, testimonials]);

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (row, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Designation",
      selector: (row) => row.designation,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header">
        <h4>Testimonials</h4>
        <Link to="/admin/addTestimonial" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Testimonial</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search testimonials..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No testimonials found</div>
          }
        />
      </div>
    </div>
  );
};

export default TestimonialList;
